export default __webpack_public_path__ + "static/media/first.bbd21c93.svg";